import { render } from "./CoreProcessInterface.vue?vue&type=template&id=d72757d6&scoped=true"
import script from "./CoreProcessInterface.vue?vue&type=script&lang=js"
export * from "./CoreProcessInterface.vue?vue&type=script&lang=js"

import "./CoreProcessInterface.vue?vue&type=style&index=0&id=d72757d6&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d72757d6"]])

export default __exports__